import { Title } from 'ui';
import { NewPasswordExpiredForm } from './new-password-expired-form';
import { NewPasswordForm } from './new-password-form';

type P = {
  email?: string;
  onNavigateToPrimaryLogin: () => void;
  onSuccessChangePassword: () => void;
  token?: string;
};

const NewPassword = ({ email, onNavigateToPrimaryLogin, onSuccessChangePassword, token }: P) => {
  const isPasswordExpired = !token;

  return (
    <>
      {isPasswordExpired ? (
        <>
          <Title level={1} marginBottom>
            Your password has expired
          </Title>
          <div className="onboarding-new-password__form-wraper">
            <NewPasswordExpiredForm
              email={email}
              onNavigateToPrimaryLogin={onNavigateToPrimaryLogin}
              onSuccessChangePassword={onSuccessChangePassword}
            />
          </div>
        </>
      ) : (
        <>
          <Title level={1} marginBottom>
            Reset password
          </Title>
          <div className="onboarding-new-password__form-wraper">
            <NewPasswordForm
              onNavigateToPrimaryLogin={onNavigateToPrimaryLogin}
              onSuccessChangePassword={onSuccessChangePassword}
              token={token}
            />
          </div>
        </>
      )}
    </>
  );
};

export default NewPassword;
